import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, { useCallback } from "react";
import { Link } from "./link";
import classNames from "classnames";
import { eventInternalLinkClick } from "../utility/datalayer";

const BadgePDP = ({ data, className, pagePath }) => {
  const onClickBadgePDP = useCallback(() => {
    eventInternalLinkClick({
      click_element: "pdp_gallery_badge",
      slug: pagePath,
    });
  }, [pagePath]);
  return data?.link ? (
    <Link
      className={classNames(
        className,
        "pdp-product-gallery__badge",
        !data?.link && "pdp-product-gallery__badge--nolink",
        data?.imageFieldSet?.image?.node?.probeInfo?.width &&
          data?.imageFieldSet?.image?.node?.probeInfo?.height &&
          data?.imageFieldSet?.image?.node?.probeInfo?.width !==
            data?.imageFieldSet?.image?.node?.probeInfo?.height &&
          "pdp-product-gallery__badge--vertical"
      )}
      to={data?.link}
      target={data?.target?.[0]}
      onClick={() => onClickBadgePDP()}
    >
      <GatsbyImage
        image={getImage(data?.imageFieldSet?.image?.node)}
        objectPosition={`${data?.imageFieldSet?.focuslr || "center"} ${
          data?.imageFieldSet?.focustb || "center"
        }`}
        alt={data?.imageFieldSet?.image?.value?.description || ""}
      />
    </Link>
  ) : (
    <button
      className={classNames(
        className,
        "pdp-product-gallery__badge pdp-product-gallery__badge--button",
        !data?.link && "pdp-product-gallery__badge--nolink",
        data?.imageFieldSet?.image?.node?.probeInfo?.width &&
          data?.imageFieldSet?.image?.node?.probeInfo?.height &&
          data?.imageFieldSet?.image?.node?.probeInfo?.width !==
            data?.imageFieldSet?.image?.node?.probeInfo?.height &&
          "pdp-product-gallery__badge--vertical"
      )}
      onClick={() => onClickBadgePDP()}
    >
      <GatsbyImage
        image={getImage(data?.imageFieldSet?.image?.node)}
        objectPosition={`${data?.imageFieldSet?.focuslr || "center"} ${
          data?.imageFieldSet?.focustb || "center"
        }`}
        alt={data?.imageFieldSet?.image?.value?.description || ""}
      />
    </button>
  );
};
export default BadgePDP;
export const fragment = graphql`
  fragment ProductBadgePDPFragment on LiferayBadgePdp {
    id
    target
    skuList
    position
    multipleLinesFieldSet {
      multipleLines
    }
    link
    imageFieldSet {
      image {
        value {
          description
        }
        node {
          gatsbyImageData(layout: FULL_WIDTH)
          publicURL
          probeInfo {
            width
            height
          }
        }
      }
      focuslr
      focustb
    }
  }
`;
